import clsx from "clsx";

import styles from "./AddItemButton.module.scss";

type AddItemButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
};

const AddItemButton = ({
  onClick,
  disabled,
  className,
  children,
}: AddItemButtonProps) => (
  <button
    type="button"
    className={clsx(styles.addItemBtn, className)}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

export default AddItemButton;
